import styled from 'styled-components';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';

export const Wrapper = styled.div`
  padding: 16px;
`;

export const SaveButton = styled(Button)`
  width: 200px;
`;
